import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentcolor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M21.406 19.885a.368.368 0 1 1-.52.52l-.803-.801-.802.802a.369.369 0 0 1-.52-.52l.802-.803-.802-.802a.368.368 0 1 1 .52-.52l.802.802.802-.802a.369.369 0 0 1 .52.52l-.801.802zm-1.323-3.718a2.918 2.918 0 0 0 0 5.833 2.918 2.918 0 0 0 0-5.833" }),
      _createElementVNode("path", { d: "M17.759 15.726a4.084 4.084 0 0 0-.706 6.096 15.2 15.2 0 0 1-6.822-.505A1.75 1.75 0 0 1 9 19.643c0-1 .344-1.972.971-2.753a3.5 3.5 0 0 1 2.514-1.3c1.4.769 3.095.769 4.495 0q.396.026.779.136M14.731 8c1.934 0 3.5 1.566 3.5 3.5s-1.566 3.5-3.5 3.5a3.5 3.5 0 0 1-3.5-3.5c0-1.934 1.567-3.5 3.5-3.5" })
    ], -1)
  ]))]))
}
export default { render: render }